import { Flex, Td, Tr } from '@chakra-ui/react'
import { formatPrice } from '../../../utils/formatPrice'
import { cnpjMask } from '../../../utils/cnpjMask'
import { format } from 'date-fns'
import { useEffect, useState } from 'react'
import { AiFillCopy } from 'react-icons/ai'

export function ControleItem({ item }) {
  if (!item) return null

  return (
    <Tr key={item.id}>
      <Td>{item.numero_unico}</Td>
      <Td>{item.numero_pedido}</Td>
      <Td>{item.numero_nota}</Td>
      <Td>{format(new Date(item?.data_pedido), 'dd/MM/yyyy HH:mm')}</Td>
      <Td>{formatPrice(item?.valor_pago)}</Td>
      <Td>{item?.tipo_pagamento}</Td>
      <Td textTransform="capitalize">{item.empresa?.toLowerCase()}</Td>
    </Tr>
  )
}
